// src/components/superadmin/BusinessCardViewer.jsx
import React, { useState } from 'react';

function BusinessCardViewer({ staff, onClose }) {
  const [showBack, setShowBack] = useState(false);

  const handleCardClick = () => {
    setShowBack(!showBack);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="card-viewer-overlay" onClick={handleOverlayClick}>
      <button className="close-viewer" onClick={onClose}>×</button>
      
      <div className={`business-card-3d ${showBack ? 'flipped' : ''}`} onClick={handleCardClick}>
        {/* FRONT FACE */}
        <div className="card-face card-front-face">
          <div className="card-top-section">
            {staff.logoUrl ? (
              <img 
                src={staff.logoUrl} 
                alt="Logo" 
                className="card-logo-img"
              />
            ) : (
              <div className="card-logo-placeholder">INSERT LOGO HERE</div>
            )}
          </div>
          <div className="card-bottom-section">
            <div className="card-info-column">
              <div className="card-job-title">{staff.title || 'Title'}</div>
              <div className="card-name">{staff.name || 'Name'}</div>
              <div className="card-contact-info">
                <div className="card-contact-item">
                  <div className="card-contact-icon">📞</div>
                  <div className="card-contact-text">{staff.phone || 'Phone'}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">✉</div>
                  <div className="card-contact-text">{staff.email}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">📍</div>
                  <div className="card-contact-text">{staff.address}</div>
                </div>
                <div className="card-contact-item">
                  <div className="card-contact-icon">🌐</div>
                  <div className="card-contact-text">www.bespokebridge.cloud</div>
                </div>
              </div>
            </div>
            <div className="card-qr-column">
              {staff.qrCodeUrl ? (
                <img 
                  src={staff.qrCodeUrl} 
                  alt="QR Code" 
                  className="card-qr-img"
                />
              ) : (
                <div className="card-qr-placeholder">INSERT QR CODE HERE</div>
              )}
            </div>
          </div>
        </div>

        {/* BACK FACE */}
        <div className="card-face card-back-face">
          <div className="card-back-content">
            {staff.logoUrlBack ? (
              <img 
                src={staff.logoUrlBack} 
                alt="Logo Back" 
                className="card-logo-back-img"
              />
            ) : (
              <div className="card-logo-back-placeholder">INSERT LOGO HERE</div>
            )}
          </div>
        </div>
      </div>
      
      <div className="card-instruction">Click card to flip</div>
    </div>
  );
}

export default BusinessCardViewer;